export type BetaNotificationDataState = {
  betaNotificationViewed: boolean;
};
export const defaultbetaNotificationState: BetaNotificationDataState = {
  betaNotificationViewed: false
};
export const BETA_NOTIFICATION_KEY = "betaNotification";
export const getBetaNotificationLocalStorage = (): unknown => {
  try {
    const localStorageState = localStorage.getItem(BETA_NOTIFICATION_KEY);
    if (!localStorageState) {
      return false;
    }

    return JSON.parse(localStorageState);
  } catch (err) {
    return false;
  }
};

export const removeBetaNotificationFromLocalStorage = () => {
  if (localStorage.getItem(BETA_NOTIFICATION_KEY) !== undefined) {
    localStorage.removeItem(BETA_NOTIFICATION_KEY);
  }
};

export const saveLocalStorage = (state: BetaNotificationDataState) => {
  if (!state) {
    state = defaultbetaNotificationState;
  }

  try {
    const serialized = JSON.stringify(state);
    localStorage.setItem(BETA_NOTIFICATION_KEY, serialized);
  } catch {
    // intentionally empty
  }
};
